type LogoProps = {
  size?: number;
  className?: string;
};

export function Logo({ size = 22, className }: LogoProps) {
  return (
    <div className={['mf-logo', className].filter(Boolean).join(' ')} style={{ width: size, height: size }}>
      <svg viewBox="0 0 22 22" width={size} height={size} style={{ position: 'absolute', inset: 0 }}>
        <path
          d="M5 14 L11 7 L17 14"
          stroke="white"
          strokeWidth={1.5}
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx={11} cy={11} r={1.1} fill="white" />
      </svg>
    </div>
  );
}

type WordmarkProps = {
  size?: number;
  sub?: boolean;
  name?: string;
};

export function Wordmark({ size = 13, sub = true, name = 'Emailforge' }: WordmarkProps) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      <Logo size={20} />
      <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 1.05 }}>
        <span style={{ fontWeight: 600, letterSpacing: -0.01, fontSize: size }}>{name}</span>
        {sub && (
          <span
            className="mono"
            style={{
              fontSize: 9.5,
              color: 'var(--ink-3)',
              letterSpacing: 0.04,
              textTransform: 'uppercase',
            }}
          >
            a contra product
          </span>
        )}
      </div>
    </div>
  );
}
